<template>
  <b-card>
    <luma-table url="account/users"
                :columns="columns"
                :model="usermodel">
      <template v-slot:actions="slotProps">
        <b-link @click="CallPermission(slotProps.item.username)"
                :to="{name: 'user-details', params: { id: slotProps.item.id, username:slotProps.item.username }}">Ansehen</b-link>
      </template>
    </luma-table>
  </b-card>
</template>
<script>
  import {ApiRoutesModel} from "@/store/models/layout/api_routes";
  import {ApiRoutesModelMixin} from "@/mixins/api_routes_model__mixin";
  import LumaTable from "@/components/LumaDatatable"
  import {User} from "@/store/models/user";
  import axios from "@/store/vue-axios"
  export default {
        name: "luma-account-list",
      components: {LumaTable},
      // mixins:[ApiRoutesModelMixin],
      data:()=>({
          usermodel:User
      }),
        computed:{
            // getAccounts(){
            //     const y = ApiRoutesModel.getRoute('get.account.users')
            //     const x = ApiRoutesModel.getResponseData(y)
            //     return x
            // },
            columns(){
                return [
                    {
                        key: 'id',
                        column: 'id',
                        filter: true,
                        order: true
                    },
                    {
                        key: 'username',
                        column: 'user',
                        filter: true,
                        order: true
                    },
                    {
                        key: 'email',
                        column: 'email',
                        filter: false,
                        order: false,
                    },
                    {
                        key: 'actions',
                        column: 'actions',
                        filter: false,
                        order: false,
                        slot: true
                    }
                ]
            },
            user(){
              return this.$currentUser.username
                // let apiobj
                // const x = this.apiRoutes.map(
                //     el=>{
                //         el.key === 'get.account' ? apiobj = el : undefined
                //     })
                // return ApiRoutesModel.getResponseData(apiobj,{user:this.$currentUser.$id})
            }
        },
        methods:{
            async CallPermission(user){
                const res = await axios.get('/account/users/'+user+'/permissions')
                    .then(response=>{
                        const b = localStorage.setItem('user_permissions',JSON.stringify(response.data['permissions']))
                    })
                    .catch(error=>error)
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/details_account/luma-account-list.vue